/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkIncidentOption
 */
export interface MarkIncidentOption {
    /**
     * 
     * @type {string}
     * @memberof MarkIncidentOption
     */
    note?: string;
}

/**
 * Check if a given object implements the MarkIncidentOption interface.
 */
export function instanceOfMarkIncidentOption(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MarkIncidentOptionFromJSON(json: any): MarkIncidentOption {
    return MarkIncidentOptionFromJSONTyped(json, false);
}

export function MarkIncidentOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkIncidentOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function MarkIncidentOptionToJSON(value?: MarkIncidentOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'note': value.note,
    };
}

